const AddEauctionModal = ({ handleClickAddEauctionModal }) => {
  return (
    <section onClick={handleClickAddEauctionModal} className="addcase_modal">
      <span>Προσθήκη ΑΦΜ οφειλέτη</span>
    </section>
  );
};

export default AddEauctionModal;
